import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=156c4d2c&scoped=true&"
import script from "./instructions.vue?vue&type=script&lang=js&"
export * from "./instructions.vue?vue&type=script&lang=js&"
import style0 from "./instructions.vue?vue&type=style&index=0&id=156c4d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c4d2c",
  null
  
)

export default component.exports